import {ReloadOutlined, SearchOutlined} from '@ant-design/icons/lib';
import {Button} from 'antd';
import {StoreFieldsFragment} from 'api/generated';
import {SearchBar} from 'components';
import {FilterInput} from 'components/FilterInput';
import {Formik, FormikHelpers} from 'formik';
import {Form, Select} from 'formik-antd';
import React from 'react';
import {NO_STORE_VALUE} from './PayoutSettings';

type FilterValues = {
  filterName: string;
  filterValue: string;
} & Partial<Record<string, string>>;

export type FilterQueryParams = {
  [key: string]: any;
};

type Props = {
  onChange: (values: FilterQueryParams) => void;
  queryFilters: FilterQueryParams;
  accountId?: string;
  stores: StoreFieldsFragment[];
  availableFilters?: Record<string, string>;
};

export const PayoutFilters: React.FC<Props> = ({
  onChange,
  queryFilters,
  availableFilters,
  stores
}) => {
  const {filters} = queryFilters;

  const initialValues: FilterValues = {
    filterName: 'storeId',
    filterValue: ''
  };

  let options = [
    {
      label: '(No store associated)',
      value: NO_STORE_VALUE
    }
  ];

  const storeOptions = stores.map((store) => ({
    label: store.name as string,
    value: store.id
  }));

  options.push(...storeOptions);

  const handleSubmit = (
    {createdAt, filterName, filterValue, ...extra}: FilterValues,
    {resetForm}: FormikHelpers<typeof initialValues>
  ) => {
    const filter: FilterQueryParams = {...filters};

    if (filterValue !== '') filter[filterName] = filterValue;

    setTimeout(resetForm, 300);
    return onChange(filter);
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({dirty, submitForm, values}) => (
        <Form>
          <SearchBar compact>
            <Select
              name="filterName"
              style={{minWidth: 250}}
              showSearch
              optionFilterProp="children"
              listHeight={500}>
              {Object.entries(availableFilters).map(([value, label]) => {
                return (
                  <Select.Option key={value} value={value}>
                    {label}
                  </Select.Option>
                );
              })}
            </Select>
            <FilterInput
              filterName={values.filterName}
              filterValue={values.filterValue}
              filterOptions={options}
            />
            <Button htmlType="submit" style={{minWidth: 130}} type={dirty ? 'primary' : undefined}>
              {dirty ? (
                <>
                  <SearchOutlined /> Search
                </>
              ) : (
                <>
                  <ReloadOutlined /> Refresh
                </>
              )}
            </Button>
          </SearchBar>
        </Form>
      )}
    </Formik>
  );
};
